<template>
<div class="chapter">
<div class="inner_page">
<p class="normal2">Gypsy: Brownish to white European moth which flits from place to place causing much damage. A serious pest.</p>
<p class="indent">Member of a scattered, nomadic people with a mind-set of its own.</p>
<p class="chap-title1"><span>Author’s Note</span></p>
<p class="normal"><i>Gypsy</i> is a work of fiction in which actual places and times are used but altered as appropriate. Occasionally the name of a real person appears for historical authenticity, though all are deceased and the story makes of them what it demands. I do not condone what happened during these times, I abhor it. But during the Occupation of France the everyday crimes of murder and arson continued to be committed, and I merely ask, by whom and how were they solved?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authour.vue?15646172